import ApiClient from './ApiClient';

class AnnouncementsAPI extends ApiClient {
  constructor() {
    super('announcements', { accountScoped: true });
  }
}

export default new AnnouncementsAPI();
